module.exports = __webpack_public_path__ + "static/media/DarkFae1.5d76fa49.png";